module.exports = __webpack_public_path__ + "img/1602memorial.942bb4cd.webp";